export default __webpack_public_path__ + "static/media/react2.e6f4d582.svg";